export enum PCRConstants {
  THROW_PCR_EXCEPTION = 'pcr/THROW_PCR_EXCEPTION',
  CREATE_PCR = 'pcr/CREATE_PCR',
  CRUD_PCR_EXCEPTION = 'pcr/CRUD_PCR_EXCEPTION',
  RESET_PCR_ERROR = 'pcr/RESET_PCR_ERROR',
  LOG_ERROR_ACTION = 'pcr/LOG_ERROR_ACTION',
}
